
import { ExtraFieldNumberConfig } from "@/models/dossier-configs/extra-field-number-config";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppExtraFieldBaseOptions from "./ExtraFieldBaseOptions.vue";
import { ExtraFieldsType } from "@/utils/models/extra-fields";

export default Vue.extend({
	data(){
		return {
			config: new ExtraFieldNumberConfig()
		};
	},
	props: {
		value: {
			type: Object as ()=>ExtraFieldNumberConfig,
			required: true
		},
		optionsIndex: {
			type: Number,
			required: true
		},
		extraFieldsType: {
			type: String as ()=>ExtraFieldsType,
			required: true
		}
	},
	computed: {
		title():TranslateResult{
			return this.$ct("extra-field-num-options", {index: this.optionsIndex});
		},
		exampleNumber():string{
			return this.config.printValue(123456789.123456789);
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.config = new ExtraFieldNumberConfig(this.value);
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("input", this.config);
			this.close();
		}
	},
	components: {
		AppExtraFieldBaseOptions
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
